<template>
  <div class="back">
    <div class="thems">信息登记</div>
    <div class="remark" v-if="enterForm">
      <img src="@/assets/img/ico_t.png" alt="" /><span class="text"
        >您可以登记{{ years }}年度业绩信息，请前往登记！</span
      ><span class="record" @click="goRecord">信息登记</span>
    </div>
    <el-table :data="listArr" class="tableControll" empty-text="暂无数据">
      <el-table-column
        style="margin-left: 30px"
        type="index"
        label="序号"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="year" label="业绩登记年度" align="center">
      </el-table-column>
      <el-table-column prop="create_time" align="center" label="登记日期">
      </el-table-column>
      <el-table-column align="center" label="登记状态">
        <!--        "status": 1 // -1审核不通过 0待审核 1审核通过-->
        <template slot-scope="scope">
          <span v-if="scope.row.status === -1" class="red status"
            >登记退回
          </span>
          <span v-else-if="scope.row.status === 0" class="blue status"
            >登记中
          </span>
          <span v-else class="green status">已登记</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <div class="total">
            <el-link class="handle" @click="goDetail(scope.row.record_id)"
              >查看详情
            </el-link>
            <el-link
              v-if="scope.row.status === 0"
              class="handle"
              @click="goReturn(scope.row.record_id, scope.$index)"
              >撤回
            </el-link>
            <el-link
              @click="edit(scope.row.record_id)"
              v-if="scope.row.status === -1"
              class="handle"
            >
              编辑
            </el-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <ReadingNotes v-if="is_readNote === 0" v-on:readedBack="readedBack" />
  </div>
</template>

<script>
import ReadingNotes from "@/components/record/ReadingNotes";
// import { recordList, enterprise, withdraw } from "@/api/company.js";
import { recordList, getUserInfo, withdraw } from "@/api/company.js";
import { regYearEntry } from "@/api/yj.js";
import { mapState } from "vuex";
// import { skkSort } from "@/utils/skk";

export default {
  components: {
    ReadingNotes,
  },
  data() {
    return {
      listArr: [], //列表
      is_save: 0, //填写页是否有缓存  1有
      years: "",
      enterForm: true, //蓝色开放年度框
      skk_is_read_arg: 0, //用户 未阅读 登记须知
    };
  },
  computed: {
    ...mapState(["userinfo", "skk_will_be_year"]),
    //登陆须知
    is_readNote() {
      return this.userinfo.company_info.is_look_agre;
    },
  },
  async created() {
    //从后端拿状态，判断是否已阅读须知
    // console.log(this.is_readNote);
    await this.isRead();
    // console.log(this.is_readNote);
    if (this.is_readNote === 1) {
      this.skk_is_read_arg = localStorage.getItem("skk_is_read_arg");
      // console.log(this.skk_is_read_arg);

      this.is_save = this.$route.query.set;
      await this.init();
      await this.openYear();
    }
  },
  // beforeRouteUpdadte(to, from, next) {
  //   console.log("组件内的守卫");
  //   console.log(from);
  //   if (to.name === "updateIndex") {
  //     console.log("点击了 updateIndex");
  //     if (this.val === 1 && this.isUpdate) {
  //       console.log("可以正常进入 变更路由");
  //       next();
  //     } else {
  //       // next(false);
  //       console.log("不可以 进入 变更路由");
  //       this.$message.error("请先完成信息登记");
  //     }
  //   }
  // },
  methods: {
    //撤回
    async goReturn(id) {
      await withdraw({ record_id: id });

      //如果底层逻辑没有只接受成功的数据的话，要判断后端已近成功撤回，我这边才能删除
      this.$message.success("撤回成功！");
      this.$router.push({ name: "homeCreate", query: { record_id: id } });
    },
    async isRead() {
      // const res = await enterprise();
      const res = await getUserInfo();
      console.log(typeof res);
      // console.log(res.is_look_agre);
      // this.is_readNote = res.is_look_agre;
      this.$store.commit("changeReadStatus", res.is_look_agre);
      // console.log(res.is_look_agre, "res.is_look_agre");
    },
    readedBack(options) {
      console.log(options);
      this.skk_is_read_arg = localStorage.getItem("skk_is_read_arg");
      this.is_save = this.$route.query.set;
      this.init();
      this.openYear();
    },
    // 编辑
    edit(val) {
      this.$router.push({ name: "homeCreate", query: { record_id: val } });
    },
    goRecord() {
      this.$router.push({ name: "homeCreate" });
    },
    //获取开放填报的年度
    async openYear() {
      const yearArry = await regYearEntry();
      let skk_years = yearArry.year;

      if (skk_years) {
        this.years = skk_years;
      } else {
        //蓝色开放年度框隐藏
        this.enterForm = false;
      }
      this.$store.dispatch("setSkkWellBeYear", skk_years);
      // console.log(this.years, "最后拼接的年份");
    },
    //信息登记列表 （判断是否是新用户，列表数组为空，没提交过任何表单）
    async init() {
      this.listArr = await recordList();
      // console.log(this.listArr, "this.listArr");
      if (this.listArr.length > 0) {
        // 下面的逻辑是如果任何一个记录是退回的状态，就不能点上面的蓝色框框
        for (let i = 0; i < this.listArr.length; i++) {
          const elm = this.listArr[i];
          if (elm.status === -1 || elm.status === 0) {
            this.enterForm = false;
            break;
          }
        }
        // console.log("填写过表格信息的用户");
      } else {
        //有缓存 填写过信息
        // console.log("else============");
        this.$router.push({ name: "homeCreate" });
      }
    },
    //查看详情
    goDetail(val) {
      this.$router.push({ name: "recordDetail", query: { record_id: val } });
    },
  },
};
</script>

<style lang="less" scoped>
.back {
  background: #fff;
  padding: 16px 20px;
  box-sizing: border-box;
  min-height: 780px;

  .thems {
    font-size: 20px;
    color: #333333;
  }

  .remark {
    background: #eaf4ff;
    border: 1px solid #d2e7fb;
    border-radius: 2px;
    margin-top: 23px;
    display: flex;
    align-items: center;
    padding-left: 12px;
    height: 32px;

    img {
      width: 13px;
      height: 13px;
    }

    .text {
      font-size: 12px;
      color: #333333;
      margin-left: 5px;
    }

    .record {
      font-size: 12px;
      color: #4379f6;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .tableControll {
    width: 100%;
    border: solid 1px rgb(235, 238, 245);
    border-bottom: unset;
    margin-top: 10px;

    .total {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .handle {
      font-size: 12px;
      color: #666666;
      margin-left: 20px;
      text-decoration: unset;

      &:first-child {
        margin-left: unset;
      }

      &:hover {
        color: #4379f6;
      }
    }

    .link {
      color: #666666;
      text-decoration: unset;

      &:hover {
        color: #4379f6 !important;
      }
    }

    .red {
      background: #f8eaea;
      color: #f32323;
    }

    .green {
      background: #e8f8e9;
      color: #25a22d;
    }

    .blue {
      background: #d2e7fb;
      color: #4496f1;
    }

    .status {
      font-size: 12px;
      padding: 2px;
    }
  }

  /deep/ .el-table th {
    background: #f6f6f6 !important;
    color: #666;
    font-weight: normal;
  }

  /deep/ .el-table tr {
    color: #333 !important;
    font-size: 12px;
  }

  /deep/ .el-table__empty-text {
    line-height: unset;
  }
}
</style>
